import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";
import "./styles.css";

const Header = ({ setDealId, handleReset, submitForm }) => (
  <Grid container style={{ alignItems: "center" }}>
    <Grid item xs={8}>
      <h4 className="test-harness-header-text">Refi Breakeven Test Harness</h4>
    </Grid>
    <Grid item xs={4}>
      <Grid container direction="row" style={{ justifyContent: "space-between", maxWidth: "600px" }}>
        <Grid item xs={5}>
          <div className="test-harness-header-buttons-wrapper">
            <SecondaryButton
              label="Reset"
              onClick={() => {
                setDealId("");
                handleReset();
              }}
              buttonSize={ButtonSizeOptions.smFluid}
            />
          </div>
        </Grid>
        <Grid item xs={5}>
          <div className="test-harness-header-buttons-wrapper">
            <PrimaryButton
              label="Calculate"
              onClick={submitForm}
              buttonSize={ButtonSizeOptions.smFluid}
            />
          </div>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default memo(Header);
